import { Height, Padding } from "@mui/icons-material";
import {
  PrimaryLightTextColor,
  PrimaryTextColor,
  boldFont,
  getRelativeFontSize,
  mediumFont,
  primaryRedColor,
  primaryWhiteColor,
  regularFont,
} from "../../../utils/styles";

const customTableStyles = {
  table: {
    borderCollapse: "separate",
    // borderSpacing: "0 6px",
    overflow: "auto",
    border:"none"
    
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    maxHeight: "1000px",
    overflow: "auto",
  },
  tableHeaderCell: {
    fontSize:"14px",
      ...boldFont,
    // borderBottom: "1px solid #EEEFF2",
    // borderTop: "1px solid #EEEFF2",
    
  },
  tableCell: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    borderBottom: "1px solid #EEEFF2",
    maxWidth: "220px",
    fontWeight:"500"

  },
  tableCellOne: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    borderBottom: "1px solid #EEEFF2",
    maxWidth: "220px",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "rgba(237,237,237,0.7)",
      cursor: "pointer",
    },
//     "& .MuiDataGrid-virtualScrollerContent":{
//       height:"100% !important",
// minHeight:"500px !important"    }
  },
  headerCheckbox: {
    backgroundColor: "#22222C",
    minWidth:"200px"
  },


  headerName: {
    ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    textTransform: "capitalize",
    minWidth: "100px",
 
  },
  subHeaderName: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: "12px",
    textTransform: "capitalize",
    display:"flex",
  },
  footer:{
    position: "sticky",
    width: "100%",
    bottom: "0",
    background: "#f7f7f7",
    borderTop: "1px solid #E7E7EA",
    padding: "5px",
    height:"48px",
    display:"flex",
    justifyContent:"end",
  },
  footerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '11px',
    alignItems: 'center'
  },
  font:{
    "& .MuiPaginationItem-root":{
      fontSize:"13px"
    }
  },
  checkbox: {
    color: "#ffffff",
  },
  mediumFonts: {
    ...mediumFont,
    fontSize: getRelativeFontSize(5),
  },
  dataGridWrapper: {
    border: "none",
  },
  dataGridContainer: {
    // display: "flex",
    // flexDirection: "column",
    // height: "100%",
  },
  gridRow:{
    border: "none",
    "& .MuiDataGrid-columnHeaders": {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "#fff",
    },
    "& .MuiDataGrid-virtualScroller": {
      overflowY: "auto", 
    maxHeight: "calc(100vh - 345px)",
    scrollbarWidth:"thin"
    },
    "& .MuiDataGrid-virtualScrollerRenderZone":{
      fontSize:"14px"
    },
    "& .MuiDataGrid-cell":{
fontSize:"14px"
    },
    "& .MuiDataGrid-footerContainer":{
      minHeight:"0px"
    }
  },
  empty:{
    width:"86px",
    height:"24px",
    borderRadius:"2px",
    backgroundColor:"#F3F3F3"
  },
  tableGridPart:{
    // position: "relative",

    // "& .MuiDataGrid-withBorderColor":{
    //   border: "none",
    // },
   
    "& .MuiDataGrid-main": {
    
      height:"calc(100vh - 312px)",
      // marginTop:"-24px"
    },
    "& .MuiDataGrid-columnHeaders":{
      borderBottom: "1px solid #EEEFF2",
      fontSize:"14px",
      ...boldFont
    },
    "& .MuiDataGrid-rowCount":{
      display:"none",
    },
    "& .MuiSelect-select":{
      fontSize:"14px",
      padding:"4px 10px",
      border:"none",
      outline:"none",
    },
    "& .MuiOutlinedInput-notchedOutline":{
      border:"none",
      outline:"none",
    },
    "& .activeButton":{
      margin:"0 5px",background:"#3D48E5", border:"1px solid #3D48E5",
      color:primaryWhiteColor,padding:"4px", fontSize:"12px", borderRadius:"4px",
      minWidth:"30px",
      "& .activeButton:hover":{
        backgroundColor:"#3D48E5",
      },
      "& .MuiSvgIcon-root":{
        width:"0.8em",
        height:"0.8em",
      },
    },
    "& .deActiveButton":{
      margin:"0 5px",background:"#e7e7e7", border:"1px solid #e7e7e7",
      color:"#bbb",padding:"4px", fontSize:"12px", borderRadius:"4px",
      minWidth:"30px",
      "& .activeButton:hover":{
        backgroundColor:"#3D48E5",
      },
      "& .MuiSvgIcon-root":{
        width:"0.8em",
        height:"0.8em",
      },
    },
  },
  autocompleteStyle: {
    maxHeight: "42px", 
    overflow: "hidden", 
    "& .MuiAutocomplete-tag": {
      height: "auto",
    },
     "& .MuiAutocomplete-option": {
      fontSize: "12px !important",
    },
    "& .MuiChip-root": {
      maxWidth: "none", 
      overflow: "hidden", 
      textOverflow: "ellipsis", 
      whiteSpace: "nowrap", 
    },
    "& .MuiChip-label": {
      fontSize: "11px", 
      padding: "0 8px",
      textOverflow: "ellipsis", 
      whiteSpace: "nowrap", 
      overflow: "hidden", 
    },
    "& .MuiAutocomplete-popupIndicator": {
      marginLeft: "auto",
    },
    "& .MuiTextField-root": {
      maxHeight: "42px",
      borderColor: "#E7E7EA",
      
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display: "flex",
      flexWrap: "nowrap", 
      overflow: "hidden", 
      height: "40px", 
      fontSize: "14px",
      alignItems: "center", 
      paddingRight:"0px",

      "& fieldset": {
        borderColor: "#E7E7EA !important", // Force border color in all states
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA !important", 
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA !important", 
      },
    },
    "& .MuiAutocomplete-input": {
      minWidth: "0px",
    },
    "& .MuiSvgIcon-root ": {
      fontSize: "12px",
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "0px",
      alignItems: "center", 
    },
    "& .MuiTextField-root .MuiAutocomplete-inputFocused": {
      fontSize: "14px",
    },


    // "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
    //   borderColor: "#E7E7EA",
    // },
  },
  
  
  
  
  



//   autocompleteStyle: {
//     // width: "200px",
//     maxHeight: "40px",
//     overflow: "hidden", // Prevent content overflow
//     "& .MuiAutocomplete-tag": {
//       height: "auto",
//     },
//     "& .MuiChip-root": {
//       // maxWidth: "80px", // Restrict chip width
//       // overflow: "hidden",
//       textOverflow: "ellipsis",
//       whiteSpace: "nowrap",
//     },
//     "& .MuiChip-label": {
//       fontSize: "11px",
//       padding: "0 8px",
//     },
//     "& .MuiAutocomplete-popupIndicator": {
//       marginLeft: "auto",
//     },
//         "&  .MuiTextField-root": {
//       maxHeight:'38px',
//     },
//     "& .MuiOutlinedInput-root": {
//       borderRadius: "4px",
//       display:'flex',
//       // flexWrap: "initial",
//       // overflow:'hidden',
//       flexWrap:"nowrap",
//       overflow:"hidden",
//       scrollbarWidth:"none",
//       height:"38px",fontSize:"14px",
//       "&.Mui-focused fieldset": {
//         borderColor: "#E7E7EA",
//       },
//       "&:hover fieldset": {
//         borderColor: "#E7E7EA",
//       },
//     },
//     "&  .MuiAutocomplete-input":{
// minWidth:"0px"
//     },
//     "& .MuiSvgIcon-root ":{
//       display:"none"
//     },
//     "& .MuiAutocomplete-inputRoot":{
//       paddingRight:"0px"
//     }
//   },
  
  



  // autocompleteStyle: {
  //   width: "200px",
  //   maxHeight:'40px',
  //   // background: "#e7e7e7",

    // "& .MuiSvgIcon-root ":{
    //   display:"none"
    // },
  //   "& .MuiInputBase-input": {
  //     color: PrimaryTextColor,
  //     ...regularFont,
  //     fontSize: getRelativeFontSize(0),

  //     "&::placeholder": {
  //       ...regularFont,
  //       fontSize: getRelativeFontSize(0),
  //       color: PrimaryLightTextColor,
  //     },
  //   },
  //   "&  .MuiOutlinedInput-root": {
  //     padding: "0.5px 9px",
  //   },
  //   "&  .MuiTextField-root": {
  //     // maxHeight:'38px',
  //   },
    // "& .MuiOutlinedInput-root": {
    //   borderRadius: "4px",
    //   display:'flex',
    //   // flexWrap: "initial",
    //   // overflow:'hidden',
    //   flexWrap:"nowrap",
    //   overflow:"auto",
    //   scrollbarWidth:"none",
    //   height:"38px",
    //   "&.Mui-focused fieldset": {
    //     borderColor: "#E7E7EA",
    //   },
    //   "&:hover fieldset": {
    //     borderColor: "#E7E7EA",
    //   },
  //   },
  //   "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
  //     borderColor: "#E7E7EA",
  //   },
  //   "& .MuiAutocomplete-tag":{
  //     height:"auto",
  //   },
  //   "& .MuiChip-label":{
  //     fontSize:"11px",
  //     padding:"0 8px",
      
  //   },
  //   "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium":{
  //     fontSize:"16px",
  //   },
   
  // },
  menuPart:{
    display:"flex",
    alignItems:"center",
    justifyContent:"end",
    // position:"fixed"
  },
  selectBox:{
    // width:"10%",
    display:"flex",
    gap:"10px",
    // padding:"1px 10px",
    width:"100%",
    justifyContent:"end",
  
    "& .MuiInputBase-input":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-inputFocused":{
      fontSize : getRelativeFontSize(0),
    },
    "& .MuiAutocomplete-root":{
      maxHeight:"100%",
      // background:primaryGrayBg,
    },
   
    datePicker:{
      border:"1px solid #e0e0e0",
      padding:"5px 48px",
      borderRadius:"4px",
      fontSize:"14px",
      cursor:"pointer",
      fontWeight:"600",
       height:"36px"
  },
  },
  buttonArea: {
    display:"flex",
    alignItems:"center",
    justifyContent:"end",
    width:"25%",
    marginTop:"-38px",
    gap:"10px",

    "& button":{
      width:"auto",
      minWidth:"150px",
    },
  },
  dateFeild:{   
     width:"230px",  
     borderColor: "#E7E7EA",
    //  margin: '10px',             
     "& .MuiInputBase-root":{
        height:"38px",
        cursor:"pointer"
     },
     "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#E7E7EA" },
      "&:hover fieldset": { borderColor: "#E7E7EA" }, 
      "&.Mui-focused fieldset": { borderColor: "#E7E7EA" },
    },
},
  datePopover:{
    // top:"-242px",
    // left:"293px",  
    zIndex: 1300
  },
  dateSelect:{
    borderColor:"red",
    // padding: '10px' ,
    "& .MuiPickersToolbar-root":{
      padding:"4px 24px 5px 0px",
    },
    "& .MuiPickersToolbarText-root":{
      fontSize:"18px",
    },
    "& .MuiPickersLayout-contentWrapper":{
      height:"340px"
    },
    "& .MuiPickersArrowSwitcher-root":{
        padding:"5px 13px 5px 13px"
    }
  },
  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },
  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",

    "& button": {
      width: "110px",
      height:"auto",
      minWidth:"110px",
      padding:"4px",
      fontSize:"12px",
      display: "flex",
      justifyContent: "start",
      alignItems: "start",
      gap:"10px",
      "&:hover": {
        background: "none",
      },
    },
    "& .MuiSvgIcon-root":{
fontSize:"18px"
    }
  },
  popButton:{
    color:"#000",
  
    
  },
  searchBar:{
    fontWeight:400,
    fontSize:"12px",
    marginTop:"-50px",
    width:"400px",
    border:"1px solid #e7e7e7",
    borderRadius:"12px",
    height:"42px",
padding:"0px",

    '& input::placeholder': {
      fontSize: '14px',
      lineHeight: '12px',
    },
    '& .MuiSvgIcon-root': {
      height: "20px",
      width: "20px"
    },
    '& .MuiInputBase-input':{
padding:"10px 10px"
    }

  },
  textField: {
  border: "none",
  width: "100%",
  "& .MuiTextField-root": {
      maxHeight: "42px",
      borderColor: "#E7E7EA",
    },
  "& .MuiInputBase-input": {
    color: PrimaryTextColor,
    ...regularFont,
    position: "relative",
    background: "#fff",
    height: "38px",
    padding: "0 10px",
    border: "none",
    fontSize: getRelativeFontSize(0),
   
    "&::placeholder": {
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      color: PrimaryLightTextColor,
    },
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
      "& fieldset": {
        borderColor: "#E7E7EA !important", // Force border color in all states
      },
    "&.Mui-focused fieldset": {
      borderColor: "#E7E7EA",
    },
    "&:hover fieldset": {
      borderColor: "#E7E7EA",
    },
  },

  "& .MuiFormHelperText-root": {
    color: primaryRedColor,
    fontSize: getRelativeFontSize(-1),
    ...regularFont,
    marginLeft: "5px",
    marginBottom: "5px",
  },
  "& input[type='file']": {
    diaplay: "flex",
    alignItems: "center",
    padding: "5px 10px",
    height: "28px",
    fontSize: getRelativeFontSize(0),
    ...regularFont,
  },
   "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
    "& .MuiTypography-root":{
      fontSize:"14px"
    }
}

} as const;

export default customTableStyles;
